<template>
	<div class="pages bf">
    <div class="top">
    	<div class="pt20 bgfff plr20 pb20 flex flex_items flex_between ">
    		<div class="">
    			<div class="mb10">{{user.name}}</div>
    			<div class="">{{user.phone}}</div>
    		</div>
    		<div class="txt_center">
          <div class="mb20" @click="show = true">修改密码</div>
          <div class="red" @click="layout">退出</div>
        </div>
    	</div>
			<div class="linner page_bg" style="height: 10px;"></div>
    </div>
		<div class="" style="padding-top: 110px;">
			<div class="bor_b plr20 pb20 pt20 bgfff" @click="$router.push({path:'/prodetail',query:{id:item.id}})" v-for="(item,index) in list" :key="index">
				{{item.name}} 
			</div>
		</div>
    <Popup v-model="show">
      <changeUserPassw @closeFn="show = false"  @successFn="layout"></changeUserPassw>
    </Popup>
	</div>
</template>

<script>
  import changeUserPassw from "@/components/changeUserPassw";
  import { Popup } from "vant";
	export default {
		name: "home",
		props: {},
		components: {Popup,changeUserPassw},
		data() {
			return {
				user: localStorage.getItem("user") ?
					JSON.parse(localStorage.getItem("user")) : null,
				list:[],
        show:false,
			};
		},
		computed: {},
		watch: {},
		mounted() {},
		created() {
			this.getData()
		},
		beforeDestroy() {
			// window.removeEventListener("scroll", this.handleScroll);
		},
		methods: {
			getData() {
				if(!this.user){
					return
				}
				this.api.projectList().then(res => {
					this.list = res.data;
					if(this.list.length == 0){
						this.$router.push({path:'/prodetail',query:{id:this.list[0].id}})
					}
				})
			},
			layout(){
				localStorage.removeItem('user')
				localStorage.removeItem('token')
				this.$router.push('/login')
			}
		},
	};
</script>
<style lang="scss" scoped>
.top{
	position: fixed;
	top:0;
	left: 0;
	width: 100%;
	height: 110px;
	z-index: 2;
	box-sizing: border-box;
}
</style>
